import "./constants.js";
//#region src/i18n/utils.ts
/**
* @returns {string | undefined}
* Endonym ISO 639 string for given language code in given language if the parameters are valid,
* otherwise undefined
*/
const getLanguageEndonym = (languageCode) => {
	switch (languageCode.split("-").at(0)) {
		case "be": return "беларуская";
		default: return new Intl.DisplayNames(languageCode, { type: "language" }).of(languageCode);
	}
};
const getLocaleDisplayName = (localeId) => {
	if (localeId === "pseudo") return localeId;
	else return getLanguageEndonym(localeId) ?? localeId;
};
/**
* Narrows an arbitrary runtime locale ID to one of the IDs the caller supports.
*/
const isSupportedLocaleId = (localeId, supportedLocaleIds) => supportedLocaleIds.includes(localeId);
/**
* Resolves an arbitrary runtime locale ID (e.g. Lingui's `i18n.locale`)
* to an Open Graph-compatible POSIX locale ID.
*
* IDs with no valid `language_TERRITORY` form (e.g. `pseudo`) fall back to the source locale.
*/
const getPosixLocaleId = ({ localeId, posixLocaleIdMap, supportedLocaleIds }) => isSupportedLocaleId(localeId, supportedLocaleIds) ? posixLocaleIdMap[localeId] : posixLocaleIdMap["en"];
//#endregion
export { getLanguageEndonym, getLocaleDisplayName, getPosixLocaleId, isSupportedLocaleId };

//# sourceMappingURL=utils.js.map